import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 
import LazyLoad from 'react-lazy-load';

import NewsletterForm from '../../components/newletter-form'

import Wrapper from './wrapper'
import MenuSection from './menu-section'
import CitiesSection from './cities-section'
import FeaturedSection from './featured-section'
import PromotedSection from './promoted-section'
import CategoriesSection from './categories-section'
import FeaturedStorySection from './featured-story-section'

// import walkingImage from '../../images/walking.png'

class HomePage extends Component {

    render() {
        return (
            <Wrapper>
                <Helmet>
                    <title>{this.props.seo.title?this.props.seo.title:'Startup Guide'}</title>
                    <meta content={this.props.seo.description?this.props.seo.description:"As the world of work changes, our mission is to guide, empower and inspire people to start their own business anywhere."} name="description" />

                    <meta content="website" property="og:type" />
                    <meta content={this.props.generic&&this.props.generic.title?this.props.generic.title:this.props.title} property="og:title" />
                    <meta content={this.props.generic&&this.props.generic.description?this.props.generic.description:this.props.subtitle} property="og:description" />
                    <meta content={this.props.generic&&this.props.generic.image?this.props.generic.image:this.props.thumbnail} property="og:image" />
                    <meta property="og:url" content="https://startupguide.com"></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={this.props.twitter&&this.props.twitter.type.includes('Standard')?'summary':'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={this.props.twitter&&this.props.twitter.handle?this.props.twitter.handle:'@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={this.props.twitter&&this.props.twitter.title?this.props.twitter.title:this.props.title}></meta>
                    <meta name="twitter:description" content={this.props.twitter&&this.props.twitter.description?this.props.twitter.description:this.props.subtitle}></meta>
                    <meta name="twitter:image" content={this.props.twitter&&this.props.twitter.image?this.props.twitter.image:this.props.thumbnail}></meta>
                    <script type="application/ld+json">{`
                    {
                      "@context": "http://schema.org",
                      "@type": "NewsMediaOrganization",
                      "name": "Startup Guide",
                      "url": "https://startupguide.com/",
                      "logo": "https://startupguide.com/static/media/sg-logo.323e1d72.svg",
                      "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+49 30 37468679",
                        "contactType": "customer service",
                        "areaServed": "DE",
                        "availableLanguage": "English"
                      },
                      "sameAs": [
                        "https://www.facebook.com/StartupGuideHQ/",
                        "https://twitter.com/StartupGuideHQ/",
                        "https://www.instagram.com/startupguidehq/",
                        "https://www.youtube.com/channel/UCvhUxkZtfB8z0gpx4hq-aaA/featured",
                        "https://www.linkedin.com/company/startupguidehq/"
                      ]
                    }
                    `}</script>
                    <script type="application/ld+json">{`
                    {
                      "@context": "http://schema.org/",
                      "@type": "WebSite",
                      "name": "Startup Guide",
                      "url": "https://startupguide.com/",
                      "potentialAction": {
                        "@type": "SearchAction",
                        "target": "https://startupguide.com/{search_term_string}?src=mc_google",
                        "query-input": "required name=search_term_string"
                      }
                    }
                    `}</script>
                    <script type="application/ld+json">{`
                        {
                            "@context": "http://schema.org",
                            "@id": "https://www.startupguide.com/#webpage",
                            "@type": "WebPage",
                            "url": "https://www.startupguide.com/",
                            "name": "Startup Guide"
                        }
                    `}</script>

                </Helmet>
                <div
                    className="section-2"
                    style={{
                        backgroundColor: this.props.group.color,
                        backgroundImage: `url(${this.props.picture})`
                    }}
                >
                    <div className="container-2 w-container hero-container">
                        <Link to={this.props.link} className="link-block-4 w-inline-block">
                            <h1 className="heading-6">
                                <strong className="top-story-headline">
                                    {this.props.title}
                                </strong>
                            </h1>
                            <p className="paragraph">{this.props.subtitle}</p>
                        </Link>
                        <Link to={this.props.link} className="read-more-white w-button">
                            READ&nbsp;MORE
                        </Link>
                    </div>
                </div>
                {this.props.children}
            </Wrapper>
        )
    }
}

const connectRelay = HomePage => class extends Component {

    render() {

        var blockLazy = (/blocklazy/gi).test(window.location.href);
        const { routeResolver } = this.props.context
        const parent = this.props.home.headerArticle.city || this.props.home.headerArticle.category
        // console.log("PROPS",this.props);
        const props = {
            title: this.props.home.headerTitle,
            subtitle: this.props.home.headerSubtitle,
            picture: this.props.home.headerPicture,
            thumbnail: this.props.home.headerArticle.picture,
            group: parent,
            link: parent && routeResolver.article.get(
                parent.slug,
                this.props.home.headerArticle.slug
            ),
            home: this.props.home,
            seo: this.props.home.seo,
            generic: this.props.home.social.generic[0],
            twitter: this.props.home.social.twitter[0]
        }

        var BannerHome = [];
        if (this.props.home.highlights && this.props.home.highlights.nomination && this.props.home.highlights.nomination[0] && this.props.home.highlights.nomination[0].link) {
            console.log(this.props.home.highlights.nomination[0])
            for (var ind in this.props.home.highlights.nomination) {
                if (this.props.home.highlights.nomination[ind].link) {
                    var styleBannerHome = {}
                    if (this.props.home.highlights.nomination[ind].color) {
                        styleBannerHome.backgroundColor =  `${this.props.home.highlights.nomination[ind].color}`
                    }

                    if (this.props.home.highlights.nomination[ind].card_image) {
                        styleBannerHome.backgroundImage =  `url(${this.props.home.highlights.nomination[ind].card_image})`
                    }
                     
                    var BannerText = ""
                    if (this.props.home.highlights.nomination[ind].text) {
                        BannerText = <div className="text-block-14 center-600">
                            <strong className="bold-text-92">
                                {this.props.home.highlights.nomination[ind].text}
                            </strong>
                        </div>
                    }
                    BannerHome.push(<div className="banner-homepage">
                        <a style={styleBannerHome} href={this.props.home.highlights.nomination[ind].link} target="_blank" className="image-link-banner w-inline-block">
                            {BannerText}
                        </a>
                    </div>)
                }
            }
        }

        return (
            <HomePage {...props}>
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <FeaturedSection {...this.props} />
                    </LazyLoad>
                }
                {BannerHome}
                {blockLazy &&
                    <FeaturedStorySection {...this.props} />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <FeaturedStorySection {...this.props} />
                    </LazyLoad>
                }
                {blockLazy &&
                    <FeaturedStorySection {...this.props} />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <CitiesSection {...this.props} />
                    </LazyLoad>
                }
                {blockLazy &&
                    <CitiesSection {...this.props} />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <PromotedSection {...this.props} />
                    </LazyLoad>
                }
                {blockLazy &&
                    <PromotedSection {...this.props} />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <CategoriesSection {...this.props} />
                    </LazyLoad>
                }
                {blockLazy &&
                    <CategoriesSection {...this.props} />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <NewsletterForm />
                    </LazyLoad>
                }
                {blockLazy &&
                    <NewsletterForm />
                }
                {!blockLazy &&
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <MenuSection {...this.props} />
                    </LazyLoad>
                }
                {blockLazy &&
                    <MenuSection {...this.props} />
                }
            </HomePage>
        )
    }
}

export default createFragmentContainer(
    connectRelay(HomePage),
    graphql`
        fragment homePage_home on Home {
            headerTitle
            headerSubtitle
            headerPicture
            headerArticle {
                slug
                picture
                city {
                    slug
                    color
                }
            }
            highlights{
              nomination{
                card_image
                link
                text
                color
              }
            }
            seo {
                title
                description
            }
            social {
                twitter {
                    type
                    title
                    image
                    handle
                    description
                }
                generic {
                    title
                    image
                    description
                }
            }
            ...featuredSection_home
            ...promotedSection_home
            ...citiesSection_home
            ...featuredStorySection_home
            ...categoriesSection_home
            ...menuSection_home
        }
    `
)
